export default __webpack_public_path__ + "static/0.17-2d6d04cc8f9bdae5a8294df83dc6696e.png";